componentRegistryInstance.register('rating', 'read', 'hrd.components.form.RatingComponent');

hrd.components.form.RatingComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.RatingComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		// force same height of container
		field.css('height', field.parent().height());
		// use of jRate.js plugin for managing stars
		let sRatingFn = $.functionCase(field.data('name') + '-rating-options');
		let ratingOptions;
		if (this.settings.reference && typeof this.settings.reference[sRatingFn] === 'function') {
			ratingOptions = this.settings.reference[sRatingFn].call(this.settings.reference, field, this.getFormInstance());
		} else {
			console.log(`function "${sRatingFn}" not available in proper object reference "${this.settings.reference._FULL_}". Add "${sRatingFn}: function(field, formInstance){}," in order to configure rating properly`);
		}
		ratingOptions = $.extend({}, this.getRatingDefaults(), ratingOptions);
		let ratingInstance = field.jRate(ratingOptions)
		field.data('ratingOptions', ratingOptions);
		field.data('ratingInstance', ratingInstance);
	},
	setReadOnlyField: function(field, value, object, options) {
		let ratingInstance = field.data('ratingInstance');
		if (value != undefined) {
			ratingInstance.draw(value);
		} else {
			ratingInstance.draw();
		}
	},
	resetReadOnlyField: function(field, options) {
		let ratingOptions = field.data('ratingOptions');
		let ratingInstance = field.data('ratingInstance');
		ratingInstance.draw(ratingOptions.min);
	},
	getRatingDefaults: function() {
		let ratingDefaults = {
			drawOnStart: false,
			readOnly: true,
			rating: 0,
			shape: "STAR", //STAR, RECTANGLE, SQUARE, CIRCLE, RHOMBUS, TRIANGLE, FOOD, TWITTER, BULB, BASKET
			count: 5,
			width: "20",
			height: "20",
			widthGrowth: 0.0,
			heightGrowth: 0.0,
			backgroundColor: "white",
			startColor: "yellow",
			endColor: "yellow",
			strokeColor: "black",
			transparency: 1,
			shapeGap: "2px",
			opacity: 1,
			min: 0,
			max: 5,
			precision: 1,
			minSelected: 0,
			strokeWidth: '2px',
			horizontal: true,
			reverse: false,
			touch: true,
			onChange: null,
			onSet: null
		};
		return ratingDefaults;
	}
});